@if (spinCount > 0) {
  <div class = loading-container>
    <mat-spinner aria-label="spinner" class = "spinner-position" ></mat-spinner>
  </div>
}
